import {
  AddChargingConnectorRequest,
  ChangeChargingConnectorStatusRequest,
  GetChargingConnectorRequest,
  RemoveChargingConnectorRequest,
  UpdateChargingConnectorChargingRateRequest,
  UpdateChargingConnectorMetadataRequest,
} from './requests/charging-connector-request.ts';
import { apiClient } from './client.tsx';
import {
  AddChargingConnectorResponse,
  ChangeChargingConnectorStatusResponse,
  GetChargingConnectorResponse,
  RemoveChargingConnectorResponse,
  UpdateChargingConnectorChargingRateResponse,
  UpdateChargingConnectorMetadataResponse,
} from './responses/charging-connector-response.ts';

export const addChargingConnector = (request: AddChargingConnectorRequest) =>
  apiClient
    .post<AddChargingConnectorResponse>('/v2/charging_connectors', request)
    .then((res) => res.data.data);

export const updateChargingConnectorMetadata = (
  request: UpdateChargingConnectorMetadataRequest,
) =>
  apiClient
    .put<UpdateChargingConnectorMetadataResponse>(
      `/v2/charging_connectors/${request.connectorId}`,
      request,
    )
    .then((res) => res.data.data);

export const removeChargingConnector = (
  request: RemoveChargingConnectorRequest,
) =>
  apiClient
    .delete<RemoveChargingConnectorResponse>(
      `/v2/charging_connectors/${request.connectorId}`,
      {
        params: {
          evseId: request.evseId,
        },
      },
    )
    .then((res) => res.data.data);

export const getChargingConnector = (request: GetChargingConnectorRequest) =>
  apiClient
    .get<GetChargingConnectorResponse>(
      `/v2/charging_connectors/${request.connectorId}`,
      {
        params: {
          evseId: request.evseId,
        },
      },
    )
    .then((res) => res.data.data);

export const updateChargingConnectorChargingRate = (
  request: UpdateChargingConnectorChargingRateRequest,
) =>
  apiClient
    .put<UpdateChargingConnectorChargingRateResponse>(
      `/v2/charging_connectors/${request.connectorId}/charging_rates`,
      request,
    )
    .then((res) => res.data.data);

export const changeChargingConnectorStatus = (
  request: ChangeChargingConnectorStatusRequest,
) =>
  apiClient
    .post<ChangeChargingConnectorStatusResponse>(
      `/v2/charging_connectors/${request.connectorId}/statsu`,
      request,
    )
    .then((res) => res.data.data);
